<template>
  <TheWholesale v-if="$store.state.auth.isSignin">
    <table class="list-type-2" v-if="$store.state.wholesale.wholesales.length > 0">
      <thead>
        <tr>
          <td>No.</td>
          <td>매장 이름</td>
          <td v-if="isPC">위치 (소속상가)</td>
          <td v-if="isPC">층 / 열 / 호</td>
          <td v-if="isPC">전화번호</td>
          <td v-if="isPC">휴대폰 번호</td>
          <td v-if="isPC">
            <a-icon type="edit" />
            <span>수정</span>
          </td>
          <td v-if="isPC">
            <a-icon type="delete" />
            <span>삭제</span>
          </td>
        </tr>
      </thead>
      <tbody>
        <WholesaleItem
          v-for="(wholesale, index) in $store.state.wholesale.wholesales"
          :key="index"
          :idx="wholesale.idx"
          :name="wholesale.name"
          :location="wholesale.location"
          :phone="wholesale.phone"
          :mobile="wholesale.mobile"
          :isMine="wholesale.owner === $store.state.auth.idx"
        />
      </tbody>
    </table>
    <div class="card-empty" v-else>
      <i class="no-content-logo"></i>
      <p>아직 도매가 없습니다.</p>
    </div>
  </TheWholesale>
</template>
<script>
import TheWholesale from "@/components/Wholesale/TheWholesale";
import WholesaleItem from "@/components/Wholesale/WholesaleItem";
import { mapActions } from "vuex";

export default {
  name: "WholesaleStatus",
  components: { TheWholesale, WholesaleItem },
  methods: mapActions(["refreshWholesales"]),
  mounted() {
    this.refreshWholesales();
  }
};
</script>